import React, { useState } from 'react'
import clsx from 'clsx'
import { twMerge } from 'tailwind-merge'
import InputAdornment from '@mui/material/InputAdornment'
import TextField, { TextFieldProps } from 'components/TextField'
import { TextFieldNumberProps } from 'components/TextField/TextFieldNumber'
import { RoyaltyType } from 'models/ApiModels'
import styles from './TextFieldNftWallet.module.scss'

type TextFieldNftWalletProps = Pick<
  TextFieldProps,
  'className' | 'error' | 'label' | 'onChange' | 'disabled'
> & {
  value: RoyaltyType
  onChangePercent: TextFieldNumberProps['onChange']
  hideInputPercentage?: boolean
}

const TextFieldNftWallet: React.FC<TextFieldNftWalletProps> = props => {
  const {
    className,
    error,
    hideInputPercentage,
    label,
    disabled,
    value,
    onChangePercent,
    onChange
  } = props

  const [isFocus, setFocus] = useState(false)

  const isFocusAdjusted = value.address || isFocus

  return (
    <div
      className={twMerge(
        'relative flex w-full',
        styles.TextFieldWrapper,
        isFocusAdjusted && styles.TextFieldWrapperFocus,
        error && styles.TextFieldWrapperError,
        className
      )}
    >
      <TextField
        className="w-1/100 min-w-0 flex-auto"
        color="secondary-alt"
        variant="filled"
        value={value.address}
        disabled={disabled}
        error={error}
        onChange={onChange}
        InputProps={{
          className: styles.Input
        }}
        inputProps={{
          autoComplete: 'off'
        }}
        onFocus={() => {
          setFocus(true)
        }}
        onBlur={() => {
          setFocus(false)
        }}
        fullWidth
      />

      {!hideInputPercentage ? (
        <TextField
          className="w-20"
          color="secondary-alt"
          variant="filled"
          type="number"
          value={value.initial_sale_fee_in_bp}
          error={error}
          disabled={disabled}
          onChange={onChangePercent}
          InputProps={{
            className: styles.Input,
            classes: {
              input: twMerge(
                'py-4 text-right',
                styles.TextFieldSecondaryInput,
                isFocusAdjusted && styles.TextFieldSecondaryInputFocus
              )
            },
            endAdornment: (
              <InputAdornment
                className={twMerge(
                  styles.TextFieldSecondaryAdornmentEnd,
                  isFocusAdjusted && styles.TextFieldSecondaryAdornmentEndFocus
                )}
                position="end"
              >
                %
              </InputAdornment>
            )
          }}
          inputProps={{
            autoComplete: 'off'
          }}
          onFocus={() => {
            setFocus(true)
          }}
          onBlur={() => {
            setFocus(false)
          }}
          fullWidth
        />
      ) : null}

      <div
        className={clsx(
          'pointer-events-none absolute left-0 top-0 z-1 truncate text-base font-normal',
          styles.LabelWrapper,
          isFocusAdjusted && styles.LabelWrapperFocus
        )}
      >
        {label}
      </div>
    </div>
  )
}

export default TextFieldNftWallet
